<template>
  <div
    class="d-flex justify-end"
    :class="{ 'flex-row-reverse': !justifyEnd, 'mt-1': hideDetails }"
  >
    <div
      class="pa-1 text-end d-flex flex-column message-container"
      :class="{ 'align-end': ownMessage }"
      style="max-width: 60%"
    >
      <template v-if="!hideDetails">
        <div
          class="fs-exclude body-2"
          style="line-height: 1.1"
        >
          {{ message.author }}
        </div>
        <div
          class="px-1"
          style="line-height: 1.1"
        >
          <span class="caption font-weight-bold primary--text">{{ message.created | prettyDate }}</span>
        </div>
      </template>
      <div
        :class="{ 'other-message': !ownMessage, 'primary white--text': ownMessage }"
        class="fs-mask message-box subtitle-1 px-3 py-2"
      >
        <span>{{ message.text }}</span>
      </div>
    </div>
    <div
      style="width: 48px; height: 48px"
      class="mx-3"
    >
      <v-avatar
        v-if="!hideDetails"
        :color="ownMessage ? 'primary' : 'grey'"
      >
        <v-icon dark>
          person
        </v-icon>
      </v-avatar>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    message: { type: Object, required: true },
    hideDetails: { type: Boolean, default: false },
    ownMessage: { type: Boolean, default: false }
  },
  computed: {
    justifyEnd() {
      return this.ownMessage
    }
  }
}
</script>

<style scoped lang="scss">
  .message-box {
    max-width: 100%;
    border-radius: 5px;
    border-top-right-radius: 0px;
  }

  .message-box span {
    max-width: 100%;
    word-wrap: break-word !important;
    white-space: pre-line;
  }

  .message-box.other-message {
    width: fit-content;
    background-color: rgb(232, 232, 232);
    border-top-left-radius: 0px;
    border-top-right-radius: 5px;
  }
</style>
